import React from 'react';
import classNames from 'classnames';

import COLORS from '../../../constants/colors.constants';

export const CloudUploadIcon = ({
  className,
  fill = COLORS.brand,
  size = '12',
  ...rest
}) => (
  <svg className={classNames(`w-${size} h-${size}`, className)} viewBox="0 0 20 14" fill="none" aria-label="upload" xmlSpace="preserve" {...rest}>
    <path d="M11.6797 7.82031H14.1797L10 3.67969L5.82031 7.82031H8.32031V11.1797H11.6797V7.82031ZM16.1328 5.35938C17.1875 5.4375 18.0859 5.90625 18.8672 6.6875C19.6094 7.46875 20 8.40625 20 9.5C20 10.6719 19.5703 11.6484 18.75 12.4688C17.9297 13.2891 16.9531 13.6797 15.8203 13.6797H5C3.59375 13.6797 2.42188 13.2109 1.44531 12.2344C0.46875 11.2578 0 10.0859 0 8.67969C0 7.46875 0.429688 6.375 1.28906 5.39844C2.14844 4.42188 3.20312 3.875 4.45312 3.71875C5 2.70312 5.74219 1.88281 6.75781 1.25781C7.73438 0.632812 8.82812 0.320312 10 0.320312C11.4062 0.320312 12.6953 0.828125 13.9062 1.80469C15.1172 2.82031 15.8594 3.99219 16.1328 5.35938Z" fill={fill}/>
  </svg>
)

export default CloudUploadIcon;
